import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  comments: [],
  loading: false,
  pagination: {},
};

const commentsReducer = createReducer(initialState)({
  [types.FETCH_COMMENTS_REQUEST]: (state) => {
    return {
      ...state,
      comments: [],
      loading: true,
    };
  },
  [types.FETCH_COMMENTS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      comments: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_COMMENTS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },

  [types.FETCH_ADD_COMMENT_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_ADD_COMMENT_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.FETCH_ADD_COMMENT_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
});

export default commentsReducer;
